import { useState } from "react";
import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import { useRuns } from "contexts/RunsContext";
import { useQueryClient } from "@tanstack/react-query";

export default function ArchiveRunMenuItem({ run, onClick }) {
  const { deleteRun } = useRuns();
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  const onCancel = () => {
    setOpen(false);
  };

  const onArchive = async () => {
    await deleteRun(run.id);
    setOpen(false);
    // wait for a while for backend to archive the project statistics
    setTimeout(() => {
      queryClient.invalidateQueries({ queryKey: ["/project"] });
    }, 1000);
  };

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
          onClick();
        }}
        sx={(theme) => ({
          color: theme.palette.error.main,
        })}
      >
        <DeleteOutline sx={{ mr: 1 }} fontSize="small" />
        Archive
      </MenuItem>
      <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Archive Simulation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to archive this simulation #{run.id} -{" "}
            {run.name}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onArchive}>Archive</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
